// src/pages/AdminDashboard.js
// import React from "react";
// import {
//   Box,
//   CssBaseline,
//   Drawer,
//   AppBar,
//   Toolbar,
//   Typography,
//   Divider,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   IconButton,
//   Button,
// } from "@mui/material";
// import {
//   Dashboard as DashboardIcon,
//   People as PeopleIcon,
//   Settings as SettingsIcon,
//   AttachMoney as PaymentIcon,
//   Logout as LogoutIcon,
//   Menu as MenuIcon,
  
//   Cleaning as CleaningIcon,
//   Menu as CalendarIcon,
//   Menu as NotificationsIcon,
// } from "@mui/icons-material";

// import { useNavigate } from "react-router-dom";
// import Users from "./admin/Users";
// import Settings from "./admin/Settings";
// import DashboardPage from "./admin/DashboardPage";
// import Payout from "./admin/Payout";
// import Test from "./admin/Test";


// const drawerWidth = 240;

// export default function Dashboard() {
//   const navigate = useNavigate();
//   const [mobileOpen, setMobileOpen] = React.useState(false);
//   const [selectedPage, setSelectedPage] = React.useState("Dashboard");

//   const handleLogout = () => {
//     localStorage.clear();
//     navigate("/admin/login");
//   };

//   // const menuItems = [
//   //   { text: "Dashboard", icon: <DashboardIcon /> },
//   //   { text: "Users", icon: <PeopleIcon /> },
//   //   { text: "Payout", icon: <PayoutIcon /> },
//   //   { text: "Settings", icon: <SettingsIcon /> },
//   // ];

//   const menuItems = [
//     {
//       text: "Dashboard",
//       icon: <DashboardIcon />,
//       path: "/admin",
//     },
//     {
//       text: "User Management",
//       icon: <PeopleIcon />,
//       children: [
//         { text: "Customers", path: "/admin/customers" },
//         { text: "Cleaners", path: "/admin/cleaners" },
//         { text: "User Roles", path: "/admin/user-roles" },
//       ],
//     },
//     {
//       text: "Scheduling",
//       icon: <CalendarIcon />,
//       children: [
//         { text: "Calendar View", path: "/admin/calendar" },
//         { text: "Upcoming Jobs", path: "/admin/upcoming-jobs" },
//         { text: "Schedule Management", path: "/admin/schedule-management" },
//       ],
//     },
//     {
//       text: "Service Management",
//       icon: <CleaningIcon />,
//       children: [
//         { text: "Services & Pricing", path: "/admin/services" },
//         { text: "Service Areas", path: "/admin/service-areas" },
//       ],
//     },
//     {
//       text: "Financials",
//       icon: <PaymentIcon />,
//       children: [
//         { text: "Payments", path: "/admin/payments" },
//         { text: "Invoices", path: "/admin/invoices" },
//         { text: "Earnings Reports", path: "/admin/earnings" },
//       ],
//     },
//     {
//       text: "Content & Communication",
//       icon: <NotificationsIcon />,
//       children: [
//         { text: "Notifications", path: "/admin/notifications" },
//         { text: "Reviews & Ratings", path: "/admin/reviews" },
//       ],
//     },
//     {
//       text: "Settings",
//       icon: <SettingsIcon />,
//       path: "/admin/settings",
//     },
//   ];

//   const drawer = (
//     <div>
//       <Toolbar>
//         <Typography variant="h6" noWrap>
//           Admin Panel
//         </Typography>
//       </Toolbar>
//       <Divider />
//       <List>
//         {menuItems.map((item, index) => (
//           <ListItem
//             button
//             key={index}
//             onClick={() => setSelectedPage(item.text)}
//             selected={selectedPage === item.text}
//           >
//             <ListItemIcon>{item.icon}</ListItemIcon>
//             <ListItemText primary={item.text} />
//           </ListItem>
//         ))}
//       </List>
//     </div>
//   );

//   return (
//     <Box sx={{ display: "flex" }}>
//       <CssBaseline />

//       <AppBar
//         position="fixed"
//         sx={{
//           width: { sm: `calc(100% - ${drawerWidth}px)` },
//           ml: { sm: `${drawerWidth}px` },
//         }}
//       >
//         <Toolbar sx={{ justifyContent: "space-between" }}>
//           <Box display="flex" alignItems="center">
//             <IconButton
//               color="inherit"
//               edge="start"
//               onClick={() => setMobileOpen(!mobileOpen)}
//               sx={{ mr: 2, display: { sm: "none" } }}
//             >
//               <MenuIcon />
//             </IconButton>
//             <Typography variant="h6" noWrap>
//               Admin Dashboard
//             </Typography>
//           </Box>
//           <Button color="inherit" startIcon={<LogoutIcon />} onClick={handleLogout}>
//             Logout
//           </Button>
//         </Toolbar>
//       </AppBar>

//       <Box
//         component="nav"
//         sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
//         aria-label="admin folders"
//       >
//         <Drawer
//           variant="temporary"
//           open={mobileOpen}
//           onClose={() => setMobileOpen(!mobileOpen)}
//           ModalProps={{ keepMounted: true }}
//           sx={{
//             display: { xs: "block", sm: "none" },
//             "& .MuiDrawer-paper": { width: drawerWidth },
//           }}
//         >
//           {drawer}
//         </Drawer>

//         <Drawer
//           variant="permanent"
//           sx={{
//             display: { xs: "none", sm: "block" },
//             "& .MuiDrawer-paper": { width: drawerWidth, boxSizing: "border-box" },
//           }}
//           open
//         >
//           {drawer}
//         </Drawer>
//       </Box>

//       <Box
//         component="main"
//         sx={{
//           flexGrow: 1,
//           p: 3,
//           width: { sm: `calc(100% - ${drawerWidth}px)` },
//           mt: 8,
//         }}
//       >
//         {selectedPage === "Dashboard" && <DashboardPage />}
//         {selectedPage === "Users" && <Users />}
//         {selectedPage === "Settings" && <Settings />}
//         {selectedPage === "Payout" && <Payout />}
//       </Box>
//     </Box>
//   );
// }



// src/pages/AdminDashboard.js
// import React, { useState } from "react";
// import {
//   Box,
//   CssBaseline,
//   Drawer,
//   AppBar,
//   Toolbar,
//   Typography,
//   Divider,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   IconButton,
//   Button,
//   Collapse,
//   Chip,
//   Badge,
//   Avatar,
//   Menu,
//   MenuItem,
//   useTheme,
//   useMediaQuery,
// } from "@mui/material";
// import {
//   Dashboard as DashboardIcon,
//   People as PeopleIcon,
//   Settings as SettingsIcon,
//   AttachMoney as PayoutIcon,
//   Logout as LogoutIcon,
//   Menu as MenuIcon,
//   ExpandLess,
//   ExpandMore,
//   CleaningServices as ServicesIcon,
//   CalendarMonth as ScheduleIcon,
//   Notifications as NotificationsIcon,
//   Star as ReviewsIcon,
//   AccountCircle,
//   Business as ServiceAreasIcon,
//   Receipt as InvoicesIcon,
//   Analytics as AnalyticsIcon,
// } from "@mui/icons-material";

// import { useNavigate } from "react-router-dom";
// import Users from "./admin/Users";
// import Settings from "./admin/Settings";
// import DashboardPage from "./admin/DashboardPage";
// import Payout from "./admin/Payout";
// import Services from "./admin/Services";
// import Scheduling from "./admin/Scheduling";
// import Notifications from "./admin/Notifications";
// import Reviews from "./admin/Reviews";
// import ServiceAreas from "./admin/ServiceAreas";
// import Invoices from "./admin/Invoices";
// import Analytics from "./admin/Analytics";


// import Customers from "./admin/Customers";
// import Cleaners from "./admin/Cleaners";
// import UserRoles from "./admin/UserRoles";

// const drawerWidth = 280;

// export default function Dashboard() {
//   const navigate = useNavigate();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [selectedPage, setSelectedPage] = useState("Dashboard");
//   const [openMenus, setOpenMenus] = useState({});
//   const [userMenuAnchor, setUserMenuAnchor] = useState(null);

//   // Enhanced menu structure with submenus

//   const menuItems = [
//     { text: "Dashboard", icon: <DashboardIcon />, path: "/admin" },
//     { text: "Customers", icon: <PeopleIcon />, path: "/admin/customers" },
//     { text: "Cleaners", icon: <PeopleIcon />, path: "/admin/cleaners" },
//     { text: "User Roles", icon: <PeopleIcon />, path: "/admin/user-roles" },
//     { text: "Payout", icon: <PayoutIcon />, path: "/admin/payout" },
//     { text: "Settings", icon: <SettingsIcon />, path: "/admin/settings" },
//   ];
  
//   // const menuItems = [
//   //   { 
//   //     text: "Dashboard", 
//   //     icon: <DashboardIcon />, 
//   //     badge: null 
//   //   },
    
//   //   { 
//   //     text: "User Management", 
//   //     icon: <PeopleIcon />,
//   //     children: [
//   //       { text: "All Users", badge: "12" },
//   //       { text: "Customers", badge: "8" },
//   //       { text: "Cleaners", badge: "4" },
//   //       { text: "User Roles" },
    
//   //     ]
//   //   },
//   //   { 
//   //     text: "Scheduling", 
//   //     icon: <ScheduleIcon />,
//   //     children: [
//   //       { text: "Calendar View" },
//   //       { text: "Upcoming Jobs", badge: "5" },
//   //       { text: "Job History" },
//   //     ]
//   //   },
//   //   { 
//   //     text: "Services", 
//   //     icon: <ServicesIcon />,
//   //     children: [
//   //       { text: "Service Types" },
//   //       { text: "Pricing" },
//   //       { text: "Service Areas" },
//   //     ]
//   //   },
//   //   { 
//   //     text: "Financials", 
//   //     icon: <PayoutIcon />,
//   //     children: [
//   //       { text: "Payouts", badge: "3" },
//   //       { text: "Invoices" },
//   //       { text: "Earnings Report" },
//   //       { text: "Transactions" },
//   //     ]
//   //   },
//   //   { 
//   //     text: "Content", 
//   //     icon: <ReviewsIcon />,
//   //     children: [
//   //       { text: "Reviews & Ratings", badge: "7" },
//   //       { text: "Notifications" },
//   //       { text: "Promotions" },
//   //     ]
//   //   },
//   //   { 
//   //     text: "Analytics", 
//   //     icon: <AnalyticsIcon />,
//   //   },
//   //   { 
//   //     text: "Settings", 
//   //     icon: <SettingsIcon />,
//   //   },
//   // ];

  
//   const handleLogout = () => {
//     localStorage.clear();
//     navigate("/admin/login");
//   };

//   const handleMenuToggle = (menuText) => {
//     if (menuItems.find(item => item.text === menuText)?.children) {
//       setOpenMenus(prev => ({
//         ...prev,
//         [menuText]: !prev[menuText]
//       }));
//     }
//   };

//   const handlePageSelect = (pageText) => {
//     setSelectedPage(pageText);
//     if (isMobile) {
//       setMobileOpen(false);
//     }
//   };

//   const handleUserMenuOpen = (event) => {
//     setUserMenuAnchor(event.currentTarget);
//   };

//   const handleUserMenuClose = () => {
//     setUserMenuAnchor(null);
//   };

//   const renderMenuItems = () => {
//     return menuItems.map((item) => (
//       <Box key={item.text}>
//         <ListItem
//           button
//           onClick={() => {
//             if (item.children) {
//               handleMenuToggle(item.text);
//             } else {
//               handlePageSelect(item.text);
//             }
//           }}
//           selected={selectedPage === item.text && !item.children}
//           sx={{
//             borderRadius: 1,
//             mx: 1,
//             my: 0.5,
//             "&.Mui-selected": {
//               backgroundColor: "primary.main",
//               color: "white",
//               "&:hover": {
//                 backgroundColor: "primary.dark",
//               },
//             },
//           }}
//         >
//           <ListItemIcon 
//             sx={{ 
//               color: selectedPage === item.text && !item.children ? "white" : "inherit",
//               minWidth: 40,
//             }}
//           >
//             {item.icon}
//           </ListItemIcon>
//           <ListItemText 
//             primary={item.text} 
//             primaryTypographyProps={{
//               fontSize: 14,
//               fontWeight: selectedPage === item.text ? 600 : 400,
//             }}
//           />
//           {item.badge && (
//             <Chip 
//               label={item.badge} 
//               size="small" 
//               color="error" 
//               sx={{ height: 20, minWidth: 20, fontSize: '0.75rem' }}
//             />
//           )}
//           {item.children && (
//             openMenus[item.text] ? <ExpandLess /> : <ExpandMore />
//           )}
//         </ListItem>

//         {item.children && (
//           <Collapse in={openMenus[item.text]} timeout="auto" unmountOnExit>
//             <List component="div" disablePadding>
//               {item.children.map((child) => (
//                 <ListItem
//                   key={child.text}
//                   button
//                   onClick={() => handlePageSelect(child.text)}
//                   selected={selectedPage === child.text}
//                   sx={{
//                     pl: 4,
//                     borderRadius: 1,
//                     mx: 1,
//                     my: 0.5,
//                     "&.Mui-selected": {
//                       backgroundColor: "primary.light",
//                       "&:hover": {
//                         backgroundColor: "primary.main",
//                       },
//                     },
//                   }}
//                 >
//                   <ListItemText 
//                     primary={child.text} 
//                     primaryTypographyProps={{ fontSize: 13 }}
//                   />
//                   {child.badge && (
//                     <Chip 
//                       label={child.badge} 
//                       size="small" 
//                       color="error"
//                       sx={{ height: 18, minWidth: 18, fontSize: '0.7rem' }}
//                     />
//                   )}
//                 </ListItem>
//               ))}
//             </List>
//           </Collapse>
//         )}
//       </Box>
//     ));
//   };

//   const drawer = (
//     <Box sx={{ overflow: 'auto' }}>
//       {/* Drawer Header */}
//       <Toolbar sx={{ 
//         backgroundColor: 'primary.main', 
//         color: 'white',
//         flexDirection: 'column',
//         alignItems: 'flex-start',
//         py: 2,
//       }}>
//         <Typography variant="h6" noWrap sx={{ fontWeight: 600, mb: 1 }}>
//           FreshSweeper Admin
//         </Typography>
//         <Typography variant="caption" sx={{ opacity: 0.8 }}>
//           Cleaning Service Management
//         </Typography>
//       </Toolbar>
      
//       <Divider />
      
//       {/* Quick Stats */}
//       <Box sx={{ p: 2, bgcolor: 'grey.50' }}>
//         <Typography variant="subtitle2" color="text.secondary" gutterBottom>
//           Today's Overview
//         </Typography>
//         <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
//           <Chip label="5 Jobs" size="small" color="primary" variant="outlined" />
//           <Chip label="3 Pending" size="small" color="warning" variant="outlined" />
//           <Chip label="$1.2k" size="small" color="success" variant="outlined" />
//         </Box>
//       </Box>
      
//       <Divider />
      
//       {/* Navigation Menu */}
//       <List sx={{ px: 1, py: 2 }}>
//         {renderMenuItems()}
//       </List>
//     </Box>
//   );

//   // const renderPageContent = () => {
//   //   const pageComponents = {
//   //     "Dashboard": <DashboardPage />,
//   //     "Users": <Users />,
//   //     "All Users": <Users />,
//   //     "Customers": <Users userType="customers" />,
//   //     "Cleaners": <Users userType="cleaners" />,
//   //     "User Roles": <Users userType="roles" />,
//   //     "Settings": <Settings />,
//   //     "Payout": <Payout />,
//   //     "Payouts": <Payout />,
//   //     "Services": <Services />,
//   //     "Service Types": <Services />,
//   //     "Scheduling": <Scheduling />,
//   //     "Calendar View": <Scheduling view="calendar" />,
//   //     "Upcoming Jobs": <Scheduling view="upcoming" />,
//   //     "Notifications": <Notifications />,
//   //     "Reviews & Ratings": <Reviews />,
//   //     "Service Areas": <ServiceAreas />,
//   //     "Invoices": <Invoices />,
//   //     "Analytics": <Analytics />,
//   //   };

    

//   //   return pageComponents[selectedPage] || <DashboardPage />;
//   // };


//   const renderPageContent = () => {
//     switch (selectedPage) {
//       case "Dashboard":
//         return <DashboardPage />;
//       case "Customers":
//         return <Customers />;
//       case "Cleaners":
//         return <Cleaners />;
//       case "User Roles":
//         return <UserRoles />;
//       case "Payout":
//         return <Payout />;
//       case "Settings":
//         return <Settings />;
//       default:
//         return <DashboardPage />;
//     }
//   };

//   return (
//     <Box sx={{ display: "flex" }}>
//       <CssBaseline />

//       {/* App Bar */}
//       <AppBar
//         position="fixed"
//         sx={{
//           width: { sm: `calc(100% - ${drawerWidth}px)` },
//           ml: { sm: `${drawerWidth}px` },
//           bgcolor: 'background.paper',
//           color: 'text.primary',
//           boxShadow: 1,
//         }}
//       >
//         <Toolbar sx={{ justifyContent: "space-between" }}>
//           <Box display="flex" alignItems="center">
//             <IconButton
//               color="inherit"
//               edge="start"
//               onClick={() => setMobileOpen(!mobileOpen)}
//               sx={{ mr: 2, display: { sm: "none" } }}
//             >
//               <MenuIcon />
//             </IconButton>
//             <Typography variant="h6" noWrap component="div" sx={{ fontWeight: 600 }}>
//               {selectedPage}
//             </Typography>
//           </Box>
          
//           <Box display="flex" alignItems="center" gap={2}>
//             <IconButton color="inherit">
//               <Badge badgeContent={4} color="error">
//                 <NotificationsIcon />
//               </Badge>
//             </IconButton>
            
//             <Button 
//               color="inherit" 
//               startIcon={<AccountCircle />}
//               onClick={handleUserMenuOpen}
//               sx={{ textTransform: 'none' }}
//             >
//               Admin User
//             </Button>
            
//             <Menu
//               anchorEl={userMenuAnchor}
//               open={Boolean(userMenuAnchor)}
//               onClose={handleUserMenuClose}
//             >
//               <MenuItem onClick={handleUserMenuClose}>Profile</MenuItem>
//               <MenuItem onClick={handleUserMenuClose}>Account Settings</MenuItem>
//               <Divider />
//               <MenuItem onClick={handleLogout}>
//                 <ListItemIcon>
//                   <LogoutIcon fontSize="small" />
//                 </ListItemIcon>
//                 Logout
//               </MenuItem>
//             </Menu>
//           </Box>
//         </Toolbar>
//       </AppBar>

//       {/* Navigation Drawer */}
//       <Box
//         component="nav"
//         sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
//       >
//         <Drawer
//           variant="temporary"
//           open={mobileOpen}
//           onClose={() => setMobileOpen(false)}
//           ModalProps={{ keepMounted: true }}
//           sx={{
//             display: { xs: "block", sm: "none" },
//             "& .MuiDrawer-paper": { 
//               width: drawerWidth,
//               boxSizing: "border-box",
//             },
//           }}
//         >
//           {drawer}
//         </Drawer>

//         <Drawer
//           variant="permanent"
//           sx={{
//             display: { xs: "none", sm: "block" },
//             "& .MuiDrawer-paper": { 
//               width: drawerWidth, 
//               boxSizing: "border-box",
//               border: 'none',
//               boxShadow: 2,
//             },
//           }}
//           open
//         >
//           {drawer}
//         </Drawer>
//       </Box>

//       {/* Main Content */}
//       <Box
//         component="main"
//         sx={{
//           flexGrow: 1,
//           p: 3,
//           width: { sm: `calc(100% - ${drawerWidth}px)` },
//           backgroundColor: 'grey.50',
//           minHeight: '100vh',
//         }}
//       >
//         <Toolbar /> {/* Spacer for AppBar */}
//         {renderPageContent()}
//       </Box>
//     </Box>
//   );
// }




// src/pages/AdminDashboard.js
import React, { useState } from "react";
import {
  Box,
  CssBaseline,
  Drawer,
  AppBar,
  Toolbar,
  Typography,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Button,
  Collapse,
  Chip,
  Avatar,
  Menu,
  MenuItem,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  Dashboard as DashboardIcon,
  People as PeopleIcon,
  Settings as SettingsIcon,
  AttachMoney as PayoutIcon,
  Logout as LogoutIcon,
  Menu as MenuIcon,
  ExpandLess,
  ExpandMore,
  CleaningServices as ServicesIcon,
  CalendarMonth as ScheduleIcon,
  Notifications as NotificationsIcon,
  Star as ReviewsIcon,
  AccountCircle,
  Business as ServiceAreasIcon,
  Receipt as InvoicesIcon,
  Analytics as AnalyticsIcon,
  ChevronLeft as ChevronLeftIcon,
} from "@mui/icons-material";

import { useNavigate } from "react-router-dom";
import AllUsers from "./admin/Users";
import Customers from "./admin/Customers";
import Cleaners from "./admin/Cleaners";
import UserRoles from "./admin/UserRoles";
import Settings from "./admin/Settings";
import Analytics from "./admin/Analytics";
import DashboardPage from "./admin/DashboardPage";
// import Payout from "./admin/Payout";
import Payout from "./admin/Payout";
import Services from "./admin/Services";
import ServiceAreas from "./admin/ServiceAreas";
import Pricing from "./admin/Pricing";
import Scheduling from "./admin/Scheduling";
import Earnings from "./admin/Earnings";
import Transactions from "./admin/Transactions";
import Invoices from "./admin/Invoices";
// import CalendarView from "./admin/CalendarView";
import Notifications from "./admin/Notifications";
import Reviews from "./admin/Reviews";
import Promotions from "./admin/Promotions";
import JobHistory from "./admin/JobHistory";
import Copies from "./admin/Copies"; // <-- import the new CMS page

const drawerWidth = 280;

export default function Dashboard() {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  
  const [mobileOpen, setMobileOpen] = useState(false);
  const [selectedPage, setSelectedPage] = useState("Dashboard");
  const [openMenus, setOpenMenus] = useState({
    "User Management": true, // Keep user management open by default
    "Scheduling": false,
    "Service Management": false,
    "Financials": false,
    "Content & Communication": false,
  });
  const [userMenuAnchor, setUserMenuAnchor] = useState(null);

  // Enhanced menu structure with submenus
  const menuItems = [
    { 
      text: "Dashboard", 
      icon: <DashboardIcon />, 
      path: "/admin",
      badge: null 
    },
    { 
      text: "User Management", 
      icon: <PeopleIcon />,
      children: [
        { text: "All Users", path: "/admin/users", badge: "12" },
        { text: "Customers", path: "/admin/customers", badge: "8" },
        { text: "Cleaners", path: "/admin/cleaners", badge: "4" },
        { text: "User Roles", path: "/admin/user-roles" },
        { text: "CMS", path: "/admin/copies" }, // <-- NEW CMS LINK
      ]
    },
    { 
      text: "Scheduling", 
      icon: <ScheduleIcon />,
      children: [
        // { text: "Calendar View", path: "/admin/calendar" },
        { text: "Upcoming Jobs", path: "/admin/upcoming-jobs", badge: "5" },
        { text: "Job History", path: "/admin/job-history" },
      ]
    },
    { 
      text: "Service Management", 
      icon: <ServicesIcon />,
      children: [
        { text: "Service Types", path: "/admin/services" },
        { text: "Pricing", path: "/admin/pricing" },
        { text: "Service Areas", path: "/admin/service-areas" },
      ]
    },
    { 
      text: "Financials", 
      icon: <PayoutIcon />,
      children: [
        { text: "Payouts", path: "/admin/payouts", badge: "3" },
        { text: "Invoices", path: "/admin/invoices" },
        { text: "Earnings Report", path: "/admin/earnings" },
        { text: "Transactions", path: "/admin/transactions" },
      ]
    },
    { 
      text: "Content & Communication", 
      icon: <NotificationsIcon />,
      children: [
        { text: "Reviews & Ratings", path: "/admin/reviews", badge: "7" },
        { text: "Notifications", path: "/admin/notifications" },
        { text: "Promotions", path: "/admin/promotions" },
      ]
    },
    { 
      text: "Analytics", 
      icon: <AnalyticsIcon />,
      path: "/admin/analytics",
    },
    { 
      text: "Settings", 
      icon: <SettingsIcon />,
      path: "/admin/settings",
    },
  ];

  const handleLogout = () => {
    localStorage.clear();
    navigate("/admin/login");
  };

  const handleMenuToggle = (menuText) => {
    setOpenMenus(prev => ({
      ...prev,
      [menuText]: !prev[menuText]
    }));
  };

  const handlePageSelect = (pageText, path) => {
    setSelectedPage(pageText);
    if (path) {
      navigate(path);
    }
    if (isMobile) {
      setMobileOpen(false);
    }
  };

  const handleUserMenuOpen = (event) => {
    setUserMenuAnchor(event.currentTarget);
  };

  const handleUserMenuClose = () => {
    setUserMenuAnchor(null);
  };

  const toggleDrawer = () => {
    setMobileOpen(!mobileOpen);
  };

  const renderMenuItems = () => {
    return menuItems.map((item) => (
      <Box key={item.text}>
        <ListItem
          button
          onClick={() => {
            if (item.children) {
              handleMenuToggle(item.text);
            } else {
              handlePageSelect(item.text, item.path);
            }
          }}
          selected={selectedPage === item.text && !item.children}
          sx={{
            borderRadius: 1,
            mx: 1,
            my: 0.5,
            "&.Mui-selected": {
              backgroundColor: "primary.main",
              color: "white",
              "&:hover": {
                backgroundColor: "primary.dark",
              },
            },
          }}
        >
          <ListItemIcon 
            sx={{ 
              color: selectedPage === item.text && !item.children ? "white" : "inherit",
              minWidth: 40,
            }}
          >
            {item.icon}
          </ListItemIcon>
          <ListItemText 
            primary={item.text} 
            primaryTypographyProps={{
              fontSize: 14,
              fontWeight: selectedPage === item.text ? 600 : 400,
            }}
          />
          {item.badge && (
            <Chip 
              label={item.badge} 
              size="small" 
              color="error" 
              sx={{ height: 20, minWidth: 20, fontSize: '0.75rem', mr: 1 }}
            />
          )}
          {item.children && (
            openMenus[item.text] ? <ExpandLess /> : <ExpandMore />
          )}
        </ListItem>

        {item.children && (
          <Collapse in={openMenus[item.text]} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {item.children.map((child) => (
                <ListItem
                  key={child.text}
                  button
                  onClick={() => handlePageSelect(child.text, child.path)}
                  selected={selectedPage === child.text}
                  sx={{
                    pl: 4,
                    borderRadius: 1,
                    mx: 1,
                    my: 0.5,
                    "&.Mui-selected": {
                      backgroundColor: "primary.light",
                      color: "white",
                      "&:hover": {
                        backgroundColor: "primary.main",
                      },
                    },
                  }}
                >
                  <ListItemText 
                    primary={child.text} 
                    primaryTypographyProps={{ fontSize: 13 }}
                  />
                  {child.badge && (
                    <Chip 
                      label={child.badge} 
                      size="small" 
                      color="error"
                      sx={{ height: 18, minWidth: 18, fontSize: '0.7rem' }}
                    />
                  )}
                </ListItem>
              ))}
            </List>
          </Collapse>
        )}
      </Box>
    ));
  };

  const drawer = (
    <Box sx={{ overflow: 'auto' }}>
      {/* Drawer Header */}
      <Toolbar sx={{ 
        backgroundColor: 'primary.main', 
        color: 'white',
        flexDirection: 'column',
        alignItems: 'flex-start',
        py: 2,
        minHeight: '80px !important',
      }}>
        <Typography variant="h6" noWrap sx={{ fontWeight: 600, mb: 1 }}>
          FreshSweeper Admin
        </Typography>
        <Typography variant="caption" sx={{ opacity: 0.8 }}>
          Cleaning Service Management
        </Typography>
      </Toolbar>
      
      <Divider />
      
      {/* Quick Stats */}
      <Box sx={{ p: 2, bgcolor: 'grey.50' }}>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
          Today's Overview
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          <Chip label="5 Jobs" size="small" color="primary" variant="outlined" />
          <Chip label="3 Pending" size="small" color="warning" variant="outlined" />
          <Chip label="$1.2k" size="small" color="success" variant="outlined" />
        </Box>
      </Box>
      
      <Divider />
      
      {/* Navigation Menu */}
      <List sx={{ px: 1, py: 2 }}>
        {renderMenuItems()}
      </List>
    </Box>
  );

  const renderPageContent = () => {
    const pageComponents = {
      "Dashboard": <DashboardPage />,
      "All Users": <AllUsers />, // You might want to create an AllUsers component
      "Customers": <Customers />,
      "Cleaners": <Cleaners />,
      "User Roles": <UserRoles />,
      "Settings": <Settings />,
      "Analytics": <Analytics />,
      "Payouts": <Payout />,
      "Transactions": <Transactions />,
      "Invoices": <Invoices />,
      "Earnings": <Earnings />,
      "Services": <Services />,
      "Service Types": <Services />,
      "ServiceArea": <ServiceAreas />,
      "Pricing": <Pricing />,
      "Scheduling": <Scheduling />,
      // "CalendarView": <CalendarView />,
      // "Calendar View": <Scheduling view="calendar" />,
      "Upcoming Jobs": <Scheduling view="upcoming" />,
      "JobHistory": <JobHistory />,
      "Notifications": <Notifications />,
      "Reviews & Ratings": <Reviews />,
      "Promotions": <Promotions />,
      "CMS": <Copies />, // <-- NEW CMS PAGE
    };

    return pageComponents[selectedPage] || <DashboardPage />;
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />

      {/* App Bar */}
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
          bgcolor: 'background.paper',
          color: 'text.primary',
          boxShadow: 1,
          zIndex: theme.zIndex.drawer + 1,
        }}
      >
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <Box display="flex" alignItems="center">
            <IconButton
              color="inherit"
              edge="start"
              onClick={toggleDrawer}
              sx={{ mr: 2, display: { sm: "none" } }}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" noWrap component="div" sx={{ fontWeight: 600 }}>
              {selectedPage}
            </Typography>
          </Box>
          
          <Box display="flex" alignItems="center" gap={2}>
            <Button 
              color="inherit" 
              startIcon={<AccountCircle />}
              onClick={handleUserMenuOpen}
              sx={{ textTransform: 'none' }}
            >
              Admin User
            </Button>
            
            <Menu
              anchorEl={userMenuAnchor}
              open={Boolean(userMenuAnchor)}
              onClose={handleUserMenuClose}
            >
              <MenuItem onClick={handleUserMenuClose}>Profile</MenuItem>
              <MenuItem onClick={handleUserMenuClose}>Account Settings</MenuItem>
              <Divider />
              <MenuItem onClick={handleLogout}>
                <ListItemIcon>
                  <LogoutIcon fontSize="small" />
                </ListItemIcon>
                Logout
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Navigation Drawer */}
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
      >
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={toggleDrawer}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": { 
              width: drawerWidth,
              boxSizing: "border-box",
            },
          }}
        >
          {drawer}
        </Drawer>

        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": { 
              width: drawerWidth, 
              boxSizing: "border-box",
              border: 'none',
              boxShadow: 2,
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          backgroundColor: 'grey.50',
          minHeight: '100vh',
        }}
      >
        <Toolbar /> {/* Spacer for AppBar */}
        {renderPageContent()}
      </Box>
    </Box>
  );
}